import React from 'react';
import {
  CalendarDays,
  Clock,
  MapPin,
  FileText,
  Video,
  Download,
} from "lucide-react";

const RightSidebar = ({ events, resources }) => {
  return (
    <div className="lg:col-span-3 space-y-6">
      {/* Upcoming Events */}
      <div className="bg-white rounded-lg shadow">
        <div className="px-4 py-3 border-b">
          <h3 className="text-lg font-semibold">Upcoming Events</h3>
        </div>
        <div className="p-4">
          <div className="space-y-4">
            {events.map((event) => (
              <div key={event.id} className="flex items-start space-x-3">
                <div className="flex-shrink-0">
                  <CalendarDays className="h-5 w-5 text-blue-600" />
                </div>
                <div>
                  <h4 className="font-medium">{event.title}</h4>
                  <div className="text-sm text-gray-500 space-y-1">
                    <div className="flex items-center">
                      <Clock className="h-4 w-4 mr-1" />
                      {event.date}
                    </div>
                    <div className="flex items-center">
                      <MapPin className="h-4 w-4 mr-1" />
                      {event.location}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Popular Resources */}
      <div className="bg-white rounded-lg shadow">
        <div className="px-4 py-3 border-b">
          <h3 className="text-lg font-semibold">Popular Resources</h3>
        </div>
        <div className="p-4">
          <div className="space-y-4">
            {resources.map((resource) => (
              <div key={resource.id} className="flex items-start space-x-3">
                {resource.type === 'document' && <FileText className="h-5 w-5 text-blue-600" />}
                {resource.type === 'video' && <Video className="h-5 w-5 text-blue-600" />}
                <div>
                  <h4 className="font-medium">{resource.title}</h4>
                  <p className="text-sm text-gray-500">{resource.description}</p>
                  <button className="text-blue-600 inline-flex items-center text-sm hover:underline mt-1">
                    Download
                    <Download className="ml-1 h-4 w-4" />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RightSidebar;